export default __webpack_public_path__ + "static/media/twenty-two.446b8c92.png";